import clsx from 'clsx';

import Button from '@ui/components/Button';
import IconCross from '@ui/components/icons/IconCross';

export interface CloseProps {
  className?: string;
  onClick?: () => void;
}
const Close = ({ className, onClick }: CloseProps) => (
  <div onClick={onClick} className={clsx('absolute right-6 top-6', className)}>
    <Button
      addonBefore={
        <IconCross className="fill-brand-gray-100 group-hover/button:rotate-180" />
      }
    />
  </div>
);

export default Close;
